import React, { useCallback, useState } from 'react';
import Cookies from 'js-cookie';
import { Button, CONTAINED_VARIANT, GHOST_VARIANT, NO_ICON, SIZE_48 } from '@yme/atoms/button';
import { callOptanonWrapper } from '@yme/components/Cookies/helpers';
import { useTranslation } from '@yme/services/i18n';
import { COOKIE_SAT_TRACK } from '../constants';
export function CookieButtons({ allowCookiesHandler, buttonWidth }) {
    const [cookieAllowed, setCookieAllowed] = useState('');
    const { t } = useTranslation();
    const cookieValue = JSON.parse(Cookies.get(COOKIE_SAT_TRACK) || '{}')?.allCookies;
    const acceptHandler = useCallback(() => {
        allowCookiesHandler(true);
        setCookieAllowed('true');
        callOptanonWrapper();
    }, [allowCookiesHandler]);
    const declineHandler = useCallback(() => {
        allowCookiesHandler(false);
        setCookieAllowed('false');
        callOptanonWrapper();
    }, [allowCookiesHandler]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { size: SIZE_48, hasIconButton: NO_ICON, buttonVariant: CONTAINED_VARIANT, label: t('cookies_acceptAllCookies_button'), onClick: acceptHandler, width: buttonWidth, disabled: cookieValue === 'true' || cookieAllowed === 'true' }),
        React.createElement(Button, { size: SIZE_48, hasIconButton: NO_ICON, buttonVariant: GHOST_VARIANT, label: t('cookies_declineNonEssential_button'), onClick: declineHandler, width: buttonWidth, disabled: cookieValue === 'false' || cookieAllowed === 'false' })));
}
